import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Home from "@/pages/Home";
import Results from "@/pages/Results";
import CognitiveEndpoint from "@/pages/CognitiveEndpoint";

const COGNITIVE_ROUTES = ["source", "graph", "resolve", "intent", "context", "semantic"];

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#05101f",
            border: "1px solid rgba(75,227,255,0.25)",
            color: "#F5F7FA",
            fontFamily: "JetBrains Mono, monospace",
          },
        }}
      />
      <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
        <LanguageProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/results" element={<Results />} />
              {COGNITIVE_ROUTES.map((k) => (
                <Route key={k} path={`/${k}`} element={<CognitiveEndpoint kind={k} />} />
              ))}
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
